import React from 'react'
import { DropdownItem } from 'reactstrap'
import { BsShieldLock, BsTrash } from 'react-icons/bs'

import DeleteTriviaPopup from './DeleteTriviaPopup'
import FolderSubmenu from './FolderSubmenu'
import UpdateTrivvyPrivacyModal from './UpdateTrivvyPrivacyModal'
import { canEditTrivvyPrivacy } from '../data'

// TBV-889: the list-row 3-dots actions, re-hosted in the detail page's "More
// actions" menu. `variant`: 'dropdown' (reactstrap) | 'sheet' (mobile portal).
// Duplicate is deliberately absent: TBV-886 already added it to this menu's two
// desktop branches, so adding it here again would render the entry twice once the
// branches meet.
export const TRIVVY_MORE_ACTION = {
  DELETE: 'DELETE',
  PRIVACY: 'PRIVACY',
}

export const TrivvyMoreActionsItems = ({
  item,
  user,
  variant,
  onAction,
  folderProps,
}) => {
  // Never offer these on a Trivvy that has not been saved yet.
  if (!item || !item._id) {
    return null
  }

  const profile = user && user.profile ? user.profile : null
  const showPrivacy = canEditTrivvyPrivacy(item, profile)
  const folderList = folderProps && folderProps.folders ? folderProps.folders : []
  const showFolders = folderList.length > 0

  const fire = (action) => () => {
    if (onAction) {
      onAction(action)
    }
  }

  if (variant === 'sheet') {
    return (
      <React.Fragment>
        {showPrivacy && (
          <button
            type="button"
            className="more-actions-mobile-item"
            onClick={fire(TRIVVY_MORE_ACTION.PRIVACY)}>
            <BsShieldLock size={18} /> Update Privacy
          </button>
        )}

        {showFolders && <FolderSubmenu {...folderProps} />}

        <button
          type="button"
          className="more-actions-mobile-item"
          onClick={fire(TRIVVY_MORE_ACTION.DELETE)}>
          <BsTrash size={18} /> Delete
        </button>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {showPrivacy && (
        <DropdownItem onClick={fire(TRIVVY_MORE_ACTION.PRIVACY)}>
          <BsShieldLock size={18} /> Update Privacy
        </DropdownItem>
      )}

      {showFolders && <FolderSubmenu {...folderProps} />}

      <DropdownItem onClick={fire(TRIVVY_MORE_ACTION.DELETE)}>
        <BsTrash size={18} /> Delete
      </DropdownItem>
    </React.Fragment>
  )
}

// Prop shapes mirror exactly what the Survey / KC / Message lists pass, per type.
export const TrivvyMoreActionsModals = ({
  action,
  item,
  isMessaging,
  onClose,
  onDeleted,
  onPrivacyUpdated,
}) => {
  if (!action || !item || !item._id) {
    return null
  }

  if (action === TRIVVY_MORE_ACTION.DELETE) {
    return (
      <DeleteTriviaPopup
        open
        item={item}
        onClose={onClose}
        onDeleteItem={onDeleted}
        isMessaging={isMessaging}
      />
    )
  }

  if (action === TRIVVY_MORE_ACTION.PRIVACY) {
    return (
      <UpdateTrivvyPrivacyModal
        open
        trivvy={item}
        onClose={onClose}
        onUpdateSuccess={onPrivacyUpdated}
      />
    )
  }

  return null
}

export default TrivvyMoreActionsItems
